export const COMPACTA_STORAGE_KEY = 'lista-compra-compacta';

export function leerPreferenciaCompacta(storage) {
  const store = storage || (typeof localStorage === 'undefined' ? null : localStorage);
  if (!store || typeof store.getItem !== 'function') return false;
  try {
    return store.getItem(COMPACTA_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function guardarPreferenciaCompacta(activa, storage) {
  const store = storage || (typeof localStorage === 'undefined' ? null : localStorage);
  if (!store) return false;
  try {
    if (activa) {
      if (typeof store.setItem === 'function') store.setItem(COMPACTA_STORAGE_KEY, '1');
    } else if (typeof store.removeItem === 'function') {
      store.removeItem(COMPACTA_STORAGE_KEY);
    }
    return true;
  } catch {
    return false;
  }
}

export function tachadosAbiertosPorDefecto(compacta) {
  return !compacta;
}
